import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import { BrowserRouter, Link } from 'react-router-dom';
import App from './components/App';
import logo from './assets/Logo_custom_code_small.png';
import Navigation from "./components/Navigation";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <div className="logoBanner">
                <Navigation/>

                <h2><Link to="/">Mini-Challenges </Link> </h2>

                <img src={logo} className="logo"/>
            </div>

            <div className="app-container">
                <App/>
            </div>
        </BrowserRouter>
    </React.StrictMode>
,
document.getElementById('root')
);